import { TeachingBlockVersionRoomsTable } from '../../../../../../components/TeachingBlockVersion/TeachingBlockVersionDataTables/TeachingBlockVersionRoomsTable';
import { TeachingBlockResourceConfig, TeachingBlockResourceDataPage } from '../TeachingBlockResourceDataPage';

const roomConfig: TeachingBlockResourceConfig = {
  entityType: 'room',
  exclusionHolderType: 'Room',
  relationKey: 'rooms',
  lessonFilterColumn: 'rooms',
  searchName: 'room-search',
  importLabelKey: 'rooms.title',
  // Rooms keep the pre-existing behaviour where import is enabled unless the version is readonly.
  importDisabled: (store, basicData) => {
    const versionRooms = Array.from(store.rooms.keys()).length;
    const basicRooms = basicData.roomsData?.rooms.length ?? 0;
    return store.readonly || versionRooms >= basicRooms;
  },
  getVersionUuids: (store) => Array.from(store.rooms.keys()),
  getRows: (basicData, versionUuids) =>
    basicData.roomsData?.rooms
      .filter((r) => versionUuids.includes(r.uuid))
      .map((r) => ({
        color: {},
        count: 0,
        name: r.name,
        shortName: r.roomNumber ?? '',
        uuid: r.uuid,
      })) ?? [],
  removeEntities: (store, uuids) => store.removeRooms(uuids),
  renderTable: ({ versionUuid, search, versionUuids, onRowSelection, onShowLessonClick, onRemove }) => (
    <TeachingBlockVersionRoomsTable
      versionUuid={versionUuid}
      search={search}
      versionRoomUuids={versionUuids}
      onRowSelection={onRowSelection}
      onShowLessonClick={onShowLessonClick}
      onRemove={onRemove}
    />
  ),
};

export const PlanTeachingBlockRooms = () => <TeachingBlockResourceDataPage config={roomConfig} />;
